<template>
  <div class="set">
    <van-nav-bar
      title="返利账户"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- <div
      class="name"
      @click="gomeans"
    >
      <div class="tu">
        <img
          src="../../assets/user.png"
          alt=""
        >
      </div>
      <div class="centen">
        <div class="top">{{name}}</div>
        <div class="bottom">{{mobile}}</div>
      </div>
      <div class="jian">
      </div>
    </div> -->
    <!-- <div
      class="name list"
    >
      <div class="centen">
        返利余额：
      </div>
      <div class="jian qian">
        ￥{{fanm}}
      </div>
    </div> -->
   
    <!-- <div
      class="name list"
      @click="gorevise"
    >
      <div class="centen">
        返利详情
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div> -->
    <div class="di">
      
      <div class="yu"  
        @click="goaddres">
        <p class="p1">当前余额</p>
        <p>  
        ￥{{fanm}}
        </p>
        </div>
    </div>
     <div @click="gof" class="xfan">查询更多返利详情>></div>

      <!-- <van-tabs
      v-model="active"
      @change="change"
    >
      <van-tab
        class="tab"
        :title="v"
        v-for="v in nav"
        :key="v"
      > -->
        <div class="list1">
          {{txt}}

          <div class="yue">{{times[0].y}}月  <span>{{times[0].n}}</span></div>
          <van-list
            v-model="loading"
            :finished="finished"            
            offset="500"
            @load="onLoad"    
          >
             <van-cell  v-for="(item) in list" :key="item.id"  >
              <!-- {{i}} -->
                <div class="fa">
                <div class="">{{item.create_time}} <span>{{item.remarks?item.remarks:''}} </span></div>

                <div class="din">订单号：{{item.order_sa_id}} <span></span></div>

                <div :class="item.flag==2?'money':'money1'">{{item.flag==1?'+':'-'}}￥{{item.fanli_money}}</div>
                </div>                
             </van-cell>  
          </van-list>
        </div>
        <!-- <div class="list1">
          <div class="yue">{{times[1].y}}月  <span>{{times[1].n}}</span></div>
          <van-list
            v-model="loading"
            :finished="finished"            
            offset="500"
            @load="onLoad"    
          >
             <van-cell  v-for="item in list1" :key="item.id"  >
                <div class="fa">
                <div class="din">订单号：{{item.order_sa_id}} <span></span></div>

                <div class="">{{item.create_time}}</div>
                <div :class="item.flag==2?'money':'money1'">{{item.flag==1?'+':'-'}}￥{{item.fanli_money}}</div>
                </div>                
             </van-cell>  
          </van-list>
        </div>
        <div class="list1"> 
          <div class="yue">{{times[2].y}}月  <span>{{times[2].n}}</span></div>
          <van-list
            v-model="loading"
            :finished="finished"            
            offset="500"
            @load="onLoad"    
          >
             <van-cell  v-for="item in list2" :key="item.id"  >
                <div class="fa">
                <div class="din">订单号：{{item.order_sa_id}} <span></span></div>

                <div class="">{{item.create_time}}</div>
                <div :class="item.flag==2?'money':'money1'">{{item.flag==1?'+':'-'}}￥{{item.fanli_money}}</div>
                </div>                
             </van-cell>  
          </van-list>
        </div>-->
      <!-- </van-tab>

    </van-tabs> -->
    
  </div>
</template>

<script>
import Vue from 'vue';
// import XLSXs from '../../config/exle.js'

// import { NavBar, Toast, Button, Icon } from 'vant';
// Vue.use(NavBar).use(Toast).use(Button).use(Icon)
import { NavBar, Tab, Tabs, List, Cell, Search, Dialog, Toast, CountDown,Icon } from 'vant'

Vue.use(NavBar).use(Tabs).use(Tab).use(Cell).use(List).use(Search).use(Dialog).use(CountDown).use(Icon)
export default {
  created () {
    this.name = JSON.parse(localStorage.getItem('user-name')).id
    this.mobile = JSON.parse(localStorage.getItem('user-mobile')).id
     this.axios.get('getFanliMoney',{ params: { store_id: this.$store.state.shopid } }).then(res => {
        if(res.data.code==200){
          this.fanm=res.data.data.money
          this.bi=res.data.data.rate*100
        }
          console.log(res)       
          
      }).catch(ref => {
      })
      const ti= new Date()
      // const ti= 1
      let a=0
      let  b=ti.getFullYear()
      let c=0
      console.log(ti.getMonth()-1)
      if(ti.getMonth()-1==0){
        a=1
        c=b
      }else if(ti.getMonth()-1==-1){
        a=12
        c=b-1
      }else{
        a= ti.getMonth()-1
        c=b
      }
      
      this.times =[{y:ti.getMonth()+1,n:b},{y:ti.getMonth()==0?'12':ti.getMonth(),n:ti.getMonth()==0?ti.getFullYear()-1:ti.getFullYear()} , {y:a,n:c}  ]

  },
  mounted () {
    this.deng()
    
    // window.addEventListener('scroll', this.windowScroll)
  },
  beforeDestroy () {
    // window.removeEventListener('scroll', this.windowScroll)
  },
  data () {
    return {
      name: '',
      mobile: "",
      fanm:0,
      bi:0,
      nav: ['使用', '返还'],
      active: 0,
      states: true,
      list: [],
      list1:[],
      list2:[],
      loading: false,
      finished: false,
      page: 1,
      times:'',
      txt:''
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    gomeans () {
      // this.$router.push('means')
    },
    gof(){
      this.$router.push('fanx')

    },
    goaddres () {
      // this.$router.push('fanx')
      return
      let ax=[ ['第一行第一列', '第一行第二列', '第一行第三列'],
        ['第二行第一列', '第二行第二列', '第二行第三列'],
        ['第三行第一列', '第三行第二列', '第三行第三列'],]
      // this.list.forEach(v=>{
      //   ax.push([v.create_time,v.order_sa_id,v.fanli_money])
      // })
      // console.log(ax)
      // return false
       const sheetname = 'sheet1'
        let workbook = {
          SheetNames: [sheetname],
          Sheets: {}
        }
        let sheet = XLSXs.utils.jsontosheet(ax)
        sheet.A1.v = '时间'
        sheet.B1.v ='订单号'
        sheet.C1.v = '金额'
        workbook.Sheets[sheetname] = sheet
        // 生成excel的配置项
        console.log(sheet)
        return
        const wopts = {
          bookType: 'xlsx', // 要生成的文件类型
          bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
          type: 'binary'
        };
        const wbout = XLSX.write(workbook, wopts);
        const blob = new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream"
        });
        this.download(blob, 'xlsx文件.xlsx')
    },
    gorevise () {
      this.$router.push('fanx')
    },
     deng (isd) {

    this.finished=true
      console.log(isd)
      if(isd){

      }else{
        console.log(this.times[0].n+'-'+this.times[0].y+'-30')
        let st1=this.times[0].n+'-'+this.times[0].y+'-30'
        let ed1=this.times[0].n+'-'+this.times[0].y+'-1'
        let st2=this.times[1].n+'-'+this.times[1].y+'-30'
        let ed2=this.times[1].n+'-'+this.times[1].y+'-1'
        let st3=this.times[2].n+'-'+this.times[2].y+'-30'
        let ed3=this.times[2].n+'-'+this.times[2].y+'-1'
        // JSON.stringify(st1)
        // this.txt=(new Date(ed1.replace(/-/g,'/')).getTime())

        // console.log(Date.parse(new Date(st1)))
    this.axios.post('getFanliList',{   start:(new Date(ed1.replace(/-/g,'/')).getTime())/1000  ,end:(new Date(st1.replace(/-/g,'/')).getTime())/1000,  }).then(res => {       
        this.list=res.data.data
          this.finished=true
          // console.log(res)
      }).catch(ref => {
      })
      this.axios.post('getFanliList',{  start:(new Date(ed2).getTime())/1000  ,end:(new Date(st2).getTime())/1000,  }).then(res => {       
        this.list1=res.data.data
          this.finished=true
          // console.log(res)
      }).catch(ref => {
      })
      this.axios.post('getFanliList',{  start:(new Date(ed3).getTime())/1000  ,end:(new Date(st3).getTime())/1000,  }).then(res => {       
        this.list2=res.data.data
          this.finished=true
          // console.log(res)
      }).catch(ref => {
      })
      }
       
    },
     change (name) {
      this.list = []
      this.page = 1
      this.onLoad(name)
      
      // this.download('Json.txt',this.list)
    },
    onLoad (v) {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.deng(v)
    },
    getScrollTop () {
      var scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    },
    // 获取当前可视范围的高度
    getClientHeight () {
      var clientHeight = 0
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
      }
      return clientHeight
    },

    // 获取文档完整的高度
    getScrollHeight () {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
    },
    windowScroll () {
      if (this.page == 0) {
        return false
      }
      if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 0) {
        // if (this.status === 1) {
        //   this.status = 0
        //   // 页码，分页用，默认第一页
        //   // this.deliverParams.page += 1
        //   // 调用请求函数
        //   alert('触发！！！')
        // }
        this.page++
        this.deng()
      }
    },
     s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },
     download(blob, name) {
        // 用URL.createObjectURL下载
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url;
        a.download = name;
        let event;
        if (window.MouseEvent) {
          event = new MouseEvent('click');
        } else {
          event = document.createEvent('MouseEvents');
          event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        }
        a.dispatchEvent(event);
      }
  },
}
</script>  
<style lang="less" scoped>
.di{
  background-color: rgb(45, 50, 109);
  height: 2.5rem;
  .yu{
    text-align: center;
   
    color: rgb(224, 226, 157);
    padding-top: 0.8rem;

    p{
 font-weight: 600;
    font-size: 0.5rem;
    }
    .p1{
      font-size: 0.4rem;
      padding-bottom: 0.1rem;
    }
  }
}
.xfan{
  text-align: center;
  color: rgb(239, 71, 29);
  line-height: 1rem;
  font-size: 0.4rem;
}
.ti{
  text-align: center;
  color: rgb(250, 101, 101);
  padding-top: 0.2rem;
}
.set {
  height: 100%;
  background-color: #f5f5f5;
}
.name {
  display: flex;
  height: 2.08rem;
  background-color: #fff;
  padding: 0.2rem;
  border-bottom: 1px solid #eee;
  .tu {
    flex: 0.3;
    img {
      width: 1.52rem;
    }
  }
  .centen {
    flex: 1;
    padding-top: 0.2rem;
    .top {
      font-size: 0.4rem;
      color: #333;
    }
    .bottom {
      padding-top: 0.2rem;
      font-size: 0.26rem;
      color: #999;
    }
  }
  .jian {
    flex: 0.13;
    padding-top: 0.6rem;
    font-size: 0.5rem;
    color: #e3e3e3;
  }
  .qian{
    color: #000;
    font-size: 0.4rem;
  }
}
.list {
  padding-left: 0.5rem;
  height: 1.3rem;
  .centen {
    font-size: 0.38rem;
  }
  .jian {
    flex: 0.1;
    padding-top: 0.2rem;
  }
}
.but {
  position: fixed;
  bottom: 0;
}
.fa{
    position: relative;
    // height: 10rem;
    .money{
        color: rgb(4, 162, 4);
    position: absolute;
    right: 0;
    top: 30%;}
    .money1{
        color: rgb(235, 61, 12);
    position: absolute;
    right: 0;
    top: 30%;}
    span{
      padding-left: 0.2rem;
    }
}

.sear {
  height: 1rem;
  .van-search {
    height: 1rem;
  }
}
.o_list {
  padding-top: 1.2rem;
  .bar {
    z-index: 99;
  }
}
.cs {
  text-align: center;
  color: red;
}
.tab {
  padding: 0.3rem 0;
  background-color: #f7f7f7;
}
.list1 {
  border-radius: 0.2rem;
  .yue{
    background-color: #fff;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.5rem;
    padding-left: 0.5rem;
    span{
      font-size: 0.38rem;
    }
  }
  padding-top: 0.2rem;
  background-color: #f7f7f7;
}
.van-cell {
  // margin: 0.3rem 0;
}
.shop {
  background-color: #fff;
  // padding: 0 0.3rem;
  .head {
    display: flex;
    height: 1rem;
    line-height: 1rem;
    justify-content: space-between;
    .name {
      font-size: 0.4rem;
    }
    .time {
      padding-top: 0.15rem;
      color: #a22d2b;
    }
    .state {
      font-size: 0.4rem;
      color: #a22d2b;
    }
  }
  .body {
    background-color: #fff;
    border-top: 1px solid #efefef;
    .dianj {
      text-align: center;
    }
    li {
      border-bottom: 1px solid #efefef;
      padding: 0.3rem 0;
      position: relative;

      img {
        width: 2.4rem;
        height: 2.4rem;
        float: left;
      }
      .conten {
        padding-left: 2.8rem;
        // position: absolute;
        .title {
          width: 80%;
          color: #333;
          line-height: 0.36rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .type {
          width: 90%;
          color: #888;
          padding-top: 0.2rem;
        }
        .price {
          padding-top: 0.5rem;
          font-weight: 700;
          font-size: 0.45rem;
        }
        .num {
          position: absolute;
          right: 5%;
          color: #888;
          top: 2%;
        }
      }
    }
  }
  .foot {
    .bei {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    background-color: #fff;
    .statistics {
      padding: 0.2rem;
      padding-top: 0;
      .money {
        padding-left: 0.3rem;
        font-size: 0.4rem;
        color: #333;
        span {
          font-size: 0.453333rem;
        }
      }
      .number {
        font-size: 0.4rem;
        color: #333;
      }
    }
    .but {
      text-align: right;
      padding: 0.2rem 0 0.5rem 0;
      button {
        width: 2rem;
        height: 0.8rem;
        background: #fff;

        border-radius: 5px;
        outline: none;
        margin-left: 0.2rem;
      }
      .ash {
        border: 1px solid #b0b0b0;
        color: #b0b0b0;
      }
      .red {
        border: 1px solid #a22d2b;
        color: #a22d2b;
      }
      .orange {
        border: 1px solid #f97817;
        color: #f97817;
      }
    }
  }
}
</style>